import { fetchJson } from '../store/fetch';

export async function isServiceContractedByInsurer(insurerId: string, serviceId: string) {
    const response = await fetchJson(
        `/api/insurerServiceDeclarationRules?insurerId=${insurerId}&serviceId=${serviceId}`,
        'GET'
    );

    return !!response.json?.items[0];
}
